// List of all districts in Malaysia, grouped by state for clarity
// You may flatten this if you only need the district names

const districts = [
  // Johor
  "Batu Pahat", "Johor Bahru", "Kluang", "Kota Tinggi", "Mersing", "Muar", "Pontian", "Segamat", "Tangkak", "Kulai", "Iskandar Puteri",
  // Kedah
  "Baling", "Bandar Baharu", "Kota Setar", "Kuala Muda", "Kubang Pasu", "Kulim", "Langkawi", "Padang Terap", "Pendang", "Pokok Sena", "Sik", "Yan",
  // Kelantan
  "Bachok", "Gua Musang", "Jeli", "Kota Bharu", "Kuala Krai", "Machang", "Pasir Mas", "Pasir Puteh", "Tanah Merah", "Tumpat",
  // Melaka
  "Alor Gajah", "Jasin", "Melaka Tengah",
  // Negeri Sembilan
  "Jempol", "Jelebu", "Kuala Pilah", "Port Dickson", "Rembau", "Seremban", "Tampin",
  // Pahang
  "Bentong", "Bera", "Cameron Highlands", "Jerantut", "Kuantan", "Lipis", "Maran", "Pekan", "Raub", "Rompin", "Temerloh",
  // Perak
  "Bagan Datuk", "Batu Gajah", "Batang Padang", "Hilir Perak", "Hulu Perak", "Kampar", "Kinta", "Kuala Kangsar", "Larut, Matang dan Selama", "Manjung", "Muallim", "Perak Tengah", "Kerian", "Lenggong", "Parit Buntar", "Teluk Intan", "Taiping",
  // Perlis
  "Kangar", "Padang Besar", "Arau",
  // Pulau Pinang
  "Barat Daya", "Seberang Perai Selatan", "Seberang Perai Tengah", "Seberang Perai Utara", "Timur Laut",
  // Sabah
  "Beaufort", "Beluran", "Keningau", "Kota Belud", "Kota Kinabalu", "Kota Marudu", "Kuala Penyu", "Kudat", "Kunak", "Lahad Datu", "Nabawan", "Papar", "Penampang", "Pitas", "Putatan", "Ranau", "Sandakan", "Semporna", "Sipitang", "Tambunan", "Tawau", "Tenom", "Tongod", "Tuaran",
  // Sarawak
  "Betong", "Bintulu", "Kapit", "Kuching", "Limbang", "Lubok Antu", "Miri", "Mukah", "Samarahan", "Sarikei", "Serian", "Sibu", "Sri Aman", "Asajaya", "Belaga", "Belawai", "Dalat", "Daro", "Julau", "Kanowit", "Lawas", "Lundu", "Marudi", "Meradong", "Matu", "Pakan", "Pusa", "Roban", "Sebauh", "Selangau", "Siburan", "Simunjan", "Song", "Subis", "Tatau",
  // Selangor
  "Gombak", "Hulu Langat", "Hulu Selangor", "Klang", "Kuala Langat", "Kuala Selangor", "Petaling", "Sabak Bernam", "Sepang",
  // Terengganu
  "Besut", "Dungun", "Hulu Terengganu", "Kemaman", "Kuala Nerus", "Kuala Terengganu", "Marang", "Setiu",
  // W.P. Kuala Lumpur
  "Kuala Lumpur",
  // W.P. Labuan
  "Labuan",
  // W.P. Putrajaya
  "Putrajaya",
  // Singapore
  "Tampines", "Tanjong Pagar", "Sentosa", "Ang Mo Kio", "Bukit Timah", "Geylang", "Queenstown", "Bishan", "Choa Chu Kang", 
  "Little India", "MacPherson", "Mount Faber", "Paya Lebar", "River Valley", "Upper East Coast", "Woodlands", "Clementi", 
  "District 17", "Katong", "Orchard", "Raffles Place", "Tanglin", "Yishun", "Bedok",
  // Brunei
  "Brunei-Muara", "Belait", "Tutong", "Temburong",
  // Indonesia
  "Aceh", "North Sumatra", "West Sumatra", "Riau", "Riau Islands", "Jambi", "South Sumatra", "Bangka Belitung Islands", 
  "Bengkulu", "Lampung", "Banten", "Jakarta", "Jawa Barat", "Jawa Tengah", "Yogyakarta", "Jawa Timur", "Bali", "West Nusa Tenggara", 
  "East Nusa Tenggara", "West Kalimantan", "Central Kalimantan", "South Kalimantan", "East Kalimantan", "North Kalimantan", 
  "West Sulawesi", "South Sulawesi", "Southeast Sulawesi", "Central Sulawesi", "Gorontalo", "North Sulawesi", "Maluku", "North Maluku", 
  "Papua", "West Papua", "Central Papua", "South Papua", "Papua Pegunungan", "Papua Barat Daya",
];

export const malaysiaDistricts: string[] = districts.slice().sort((a, b) => a.localeCompare(b));

